module.exports = __webpack_public_path__ + "static/img/submit.ce7619e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming2/submit.png
// module id = G3k7
// module chunks = 1